<template>
    <div class="form-group col-md-6">
        <label for="inputs_name" class="mb-0"> {{ $t('name') }} </label>
        <app-input 
            id="inputs_name" 
            class="form-control" 
            type="text" 
            v-model="selected"
            :placeholder="$t('address_name')" />
    </div>
</template>

<script>
    export default {
        name: 'nameAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
